import { render, staticRenderFns } from "./PricingContentSettings.vue?vue&type=template&id=600241db&scoped=true"
import script from "./PricingContentSettings.vue?vue&type=script&lang=js"
export * from "./PricingContentSettings.vue?vue&type=script&lang=js"
import style0 from "./PricingContentSettings.vue?vue&type=style&index=0&id=600241db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600241db",
  null
  
)

export default component.exports